module.exports = __webpack_public_path__ + "media/images/people/girl-5-a24983991547dca47e366099dbd6c813.webp";